// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login-screen {
  display: flex;
  flex-direction: column;
  height: calc(var(--vh) * 100);
  background-color: var(--login-bgcolor);
  color: var(--login-btns-bgcolor);
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
#login-screen .autologin-status {
  background-color: var(--bg-color);
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
}
#login-screen .autologin-status .status-wrapper {
  margin: auto;
}
#login-screen .autologin-status .status-wrapper .status-icon {
  font-size: 32px;
}
#login-screen .autologin-status .status-wrapper .status-text {
  font-size: 26px;
}
#login-screen .status-wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
  color: gray;
  height: initial;
}
#login-screen .status-wrapper .status-icon {
  font-size: 26px;
  margin: auto;
}
#login-screen .status-wrapper .status-text {
  font-size: 19px;
}
#login-screen .alert-cont {
  display: flex;
  background-color: var(--elem-red-color);
  padding: 11px;
  color: white;
  margin-bottom: 15px;
  border: solid 1px var(--list-item-bordercolor);
  border-radius: 5px;
}
#login-screen .alert-cont span {
  height: 20px;
}
#login-screen .btn {
  width: 100%;
  border-radius: 24px;
  font-size: 16px;
  padding: 13px 18px;
  border: none;
  outline: 0;
  color: #ffffff;
  background-color: var(--blue-login-bgcolor);
  min-height: min-content;
}
#login-screen .btn:hover,
#login-screen .btn:active,
#login-screen .btn:focus {
  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;
  background: none;
}
#login-screen .btn.btn-primary {
  color: white;
  background: var(--blue-login-bgcolor);
}
#login-screen .btn.btn-primary:hover,
#login-screen .btn.btn-primary:active,
#login-screen .btn.btn-primary:focus {
  background: var(--blue-login-bgcolor-hover);
}
#login-screen > section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow-y: auto;
}
#login-screen > section .login-block {
  display: flex;
  flex-direction: row;
  height: 70%;
  margin: 1em;
  background-color: var(--login-bgcolor);
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  max-width: 680px;
  min-height: 400px;
  overflow: hidden;
  justify-content: center;
}
#login-screen > section .login-block .side-block .block-wrapper {
  display: flex;
  align-self: center;
  flex-direction: column;
}
#login-screen > section .login-block .left-block {
  background-color: var(--blue-login-bgcolor);
  display: flex;
  flex-direction: column;
  width: 55%;
  min-width: 210px;
}
#login-screen > section .login-block .left-block .block-wrapper {
  flex: 1;
  margin-left: 0.3em;
  margin-right: 0.3em;
  margin-bottom: 0.5em;
}
#login-screen > section .login-block .left-block .block-wrapper .greeting-block {
  color: white;
  text-align: center;
}
#login-screen > section .login-block .left-block .block-wrapper .greeting-block .greeting {
  font-size: 3.2rem;
}
#login-screen > section .login-block .left-block .block-wrapper .greeting-block .slogan {
  font-size: 1.9rem;
}
#login-screen > section .login-block .left-block .block-wrapper .project-logo {
  display: flex;
  align-self: center;
  margin: 11% auto 7% auto;
  background: white;
  border-radius: 50%;
  width: 145px;
  height: 145px;
}
#login-screen > section .login-block .left-block .block-wrapper .project-logo .logo-wrapper {
  margin: 15.87%;
}
#login-screen > section .login-block .left-block .block-wrapper .project-logo .logo-wrapper img {
  object-fit: scale-down;
  margin: auto;
  width: 100px;
  height: 100px;
}
@media (max-height: 700px) {
#login-screen > section .login-block .left-block .block-wrapper .project-logo {
    margin-top: 8px;
    margin-bottom: 4px;
}
}
#login-screen > section .login-block .left-block .block-wrapper .entrance-text {
  margin-top: auto;
  color: #ffffff7f;
  text-align: center;
  font-size: 15px;
  max-height: 170px;
  display: flex;
}
#login-screen > section .login-block .left-block .block-wrapper .entrance-text span {
  margin: auto;
}
#login-screen > section .login-block .left-block .client-info {
  display: flex;
  align-self: center;
  font-size: 0.85em;
  padding-top: 1em;
  padding-bottom: 2em;
  padding-left: 1.6em;
  padding-right: 1.6em;
  color: var(--placeholder-color);
}
#login-screen > section .login-block .right-block {
  width: 45%;
  min-width: 250px;
  display: flex;
  position: relative;
  background-color: var(--bg-color3);
  justify-content: center;
}
#login-screen > section .login-block .right-block .block-wrapper {
  display: flex;
  align-self: center;
  flex-direction: column;
  height: 100%;
  width: 66%;
}
#login-screen > section .login-block .right-block .block-wrapper .entrance-status {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: var(--bg-color3);
}
#login-screen > section .login-block .right-block .block-wrapper .component-footer {
  margin-bottom: 2%;
  color: var(--login-color);
}
#login-screen .resending {
  color: var(--message-grey-color);
}
#login-screen > footer {
  display: flex;
  color: var(--login-color);
}
#login-screen > footer .copyright {
  margin: 0 2em 0.5em auto;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/login/Login.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,sCAAsC;EACtC,gCAAgC;EAChC,4KAA4K;AAC9K;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,2CAA2C;EAC3C,uBAAuB;AACzB;AACA;;;EAGE,wDAAwD;EACxD,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,qCAAqC;AACvC;AACA;;;EAGE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["#login-screen {\n  display: flex;\n  flex-direction: column;\n  height: calc(var(--vh) * 100);\n  background-color: var(--login-bgcolor);\n  color: var(--login-btns-bgcolor);\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, Roboto, \"Segoe UI\", \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n#login-screen .autologin-status {\n  background-color: var(--bg-color);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: flex;\n}\n#login-screen .autologin-status .status-wrapper {\n  margin: auto;\n}\n#login-screen .autologin-status .status-wrapper .status-icon {\n  font-size: 32px;\n}\n#login-screen .autologin-status .status-wrapper .status-text {\n  font-size: 26px;\n}\n#login-screen .status-wrapper {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  color: gray;\n  height: initial;\n}\n#login-screen .status-wrapper .status-icon {\n  font-size: 26px;\n  margin: auto;\n}\n#login-screen .status-wrapper .status-text {\n  font-size: 19px;\n}\n#login-screen .alert-cont {\n  display: flex;\n  background-color: var(--elem-red-color);\n  padding: 11px;\n  color: white;\n  margin-bottom: 15px;\n  border: solid 1px var(--list-item-bordercolor);\n  border-radius: 5px;\n}\n#login-screen .alert-cont span {\n  height: 20px;\n}\n#login-screen .btn {\n  width: 100%;\n  border-radius: 24px;\n  font-size: 16px;\n  padding: 13px 18px;\n  border: none;\n  outline: 0;\n  color: #ffffff;\n  background-color: var(--blue-login-bgcolor);\n  min-height: min-content;\n}\n#login-screen .btn:hover,\n#login-screen .btn:active,\n#login-screen .btn:focus {\n  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;\n  background: none;\n}\n#login-screen .btn.btn-primary {\n  color: white;\n  background: var(--blue-login-bgcolor);\n}\n#login-screen .btn.btn-primary:hover,\n#login-screen .btn.btn-primary:active,\n#login-screen .btn.btn-primary:focus {\n  background: var(--blue-login-bgcolor-hover);\n}\n#login-screen > section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  overflow-y: auto;\n}\n#login-screen > section .login-block {\n  display: flex;\n  flex-direction: row;\n  height: 70%;\n  margin: 1em;\n  background-color: var(--login-bgcolor);\n  border-radius: 5px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  max-width: 680px;\n  min-height: 400px;\n  overflow: hidden;\n  justify-content: center;\n}\n#login-screen > section .login-block .side-block .block-wrapper {\n  display: flex;\n  align-self: center;\n  flex-direction: column;\n}\n#login-screen > section .login-block .left-block {\n  background-color: var(--blue-login-bgcolor);\n  display: flex;\n  flex-direction: column;\n  width: 55%;\n  min-width: 210px;\n}\n#login-screen > section .login-block .left-block .block-wrapper {\n  flex: 1;\n  margin-left: 0.3em;\n  margin-right: 0.3em;\n  margin-bottom: 0.5em;\n}\n#login-screen > section .login-block .left-block .block-wrapper .greeting-block {\n  color: white;\n  text-align: center;\n}\n#login-screen > section .login-block .left-block .block-wrapper .greeting-block .greeting {\n  font-size: 3.2rem;\n}\n#login-screen > section .login-block .left-block .block-wrapper .greeting-block .slogan {\n  font-size: 1.9rem;\n}\n#login-screen > section .login-block .left-block .block-wrapper .project-logo {\n  display: flex;\n  align-self: center;\n  margin: 11% auto 7% auto;\n  background: white;\n  border-radius: 50%;\n  width: 145px;\n  height: 145px;\n}\n#login-screen > section .login-block .left-block .block-wrapper .project-logo .logo-wrapper {\n  margin: 15.87%;\n}\n#login-screen > section .login-block .left-block .block-wrapper .project-logo .logo-wrapper img {\n  object-fit: scale-down;\n  margin: auto;\n  width: 100px;\n  height: 100px;\n}\n@media (max-height: 700px) {\n#login-screen > section .login-block .left-block .block-wrapper .project-logo {\n    margin-top: 8px;\n    margin-bottom: 4px;\n}\n}\n#login-screen > section .login-block .left-block .block-wrapper .entrance-text {\n  margin-top: auto;\n  color: #ffffff7f;\n  text-align: center;\n  font-size: 15px;\n  max-height: 170px;\n  display: flex;\n}\n#login-screen > section .login-block .left-block .block-wrapper .entrance-text span {\n  margin: auto;\n}\n#login-screen > section .login-block .left-block .client-info {\n  display: flex;\n  align-self: center;\n  font-size: 0.85em;\n  padding-top: 1em;\n  padding-bottom: 2em;\n  padding-left: 1.6em;\n  padding-right: 1.6em;\n  color: var(--placeholder-color);\n}\n#login-screen > section .login-block .right-block {\n  width: 45%;\n  min-width: 250px;\n  display: flex;\n  position: relative;\n  background-color: var(--bg-color3);\n  justify-content: center;\n}\n#login-screen > section .login-block .right-block .block-wrapper {\n  display: flex;\n  align-self: center;\n  flex-direction: column;\n  height: 100%;\n  width: 66%;\n}\n#login-screen > section .login-block .right-block .block-wrapper .entrance-status {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-color3);\n}\n#login-screen > section .login-block .right-block .block-wrapper .component-footer {\n  margin-bottom: 2%;\n  color: var(--login-color);\n}\n#login-screen .resending {\n  color: var(--message-grey-color);\n}\n#login-screen > footer {\n  display: flex;\n  color: var(--login-color);\n}\n#login-screen > footer .copyright {\n  margin: 0 2em 0.5em auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
